import React from "react";

import { SlideUpModal } from "./SlideUpModal";
import { SlideUpModalInput } from "./SlideUpModalInput";
import { Stack } from "@mui/material";
import { CloseModalButton } from "./CloseModalButton";
import { ModalSubmitButton } from "./ModalSubmitButton";
import { useFormik } from "formik";
import * as Yup from "yup";
import CircularProgress from "@mui/material/CircularProgress";
import { useBeforeunload } from "react-beforeunload";

export function ReviewLoanModal({
  open,
  onClose,
  onSubmit,
  isLoading,
  isSuccessfullySent,
  error,
}) {
  useBeforeunload(isLoading ? (event) => event.preventDefault() : null);

  const formik = useFormik({
    initialValues: {
      fullName: "",
      phoneNumber: "",
      email: "",
      notes: "",
    },
    validationSchema: Yup.object().shape({
      fullName: Yup.string().required("Full name is required"),
      phoneNumber: Yup.string().test(
        "phone or email",
        "Phone number or email is required",
        function (value) {
          return value && value.length > 0 ? true : this.parent.email;
        }
      ),
      email: Yup.string()
        .email("Invalid email")
        .test(
          "phone or email",
          "Phone number or email is required",
          function (value) {
            return value && value.length > 0 ? true : this.parent.phoneNumber;
          }
        ),
    }),
    onSubmit,
  });

  return (
    <SlideUpModal open={open} onClose={onClose}>
      {isLoading && (
        <div className="review-loan-modal-container">
          <CloseModalButton onClick={onClose} />
          <Stack
            sx={{
              maxWidth: 300,
              margin: "60px 60px 10px 10px",
            }}
            gap={1}
          >
            <Stack alignItems="center" mt={8} mb={2}>
              <CircularProgress />
            </Stack>

            <h2>Sending your information...</h2>
            <span>
              Just a moment while we compile any quotes you selected and send
              them. This may take a few seconds.
            </span>
          </Stack>
        </div>
      )}

      {isSuccessfullySent && (
        <div className="review-loan-modal-container">
          <CloseModalButton onClick={onClose} />
          <Stack
            sx={{
              maxWidth: 300,
              margin: "60px 60px 10px 10px",
            }}
            gap={1}
          >
            <img
              className="review-loan-modal-header-image"
              src="/img/svg_icons/chat_review.svg"
            />
            <h2>We'll be in touch!</h2>
            <span>
              Thank you! Your information has been sent and a loan officer will
              be in touch with you soon.
            </span>
          </Stack>
        </div>
      )}

      {error && (
        <div className="review-loan-modal-container">
          <CloseModalButton onClick={onClose} />
          <Stack
            sx={{
              maxWidth: 300,
              margin: "60px 60px 10px 10px",
            }}
            gap={1}
          >
            <img
              className="review-loan-modal-header-image"
              src="/img/svg_icons/chat_review.svg"
            />
            <h2>Something went wrong</h2>
            <span>
              We're sorry, we weren't able to process your request at this time.
              Please try again later.
            </span>
          </Stack>
        </div>
      )}

      {!isLoading && !isSuccessfullySent && !error && (
        <form onSubmit={formik.handleSubmit}>
          <div className="review-loan-modal-container">
            <CloseModalButton onClick={onClose} />
            <Stack
              sx={{
                maxWidth: 300,
                margin: "60px 60px 10px 10px",
              }}
              gap={1}
            >
              <img
                className="review-loan-modal-header-image"
                src="/img/svg_icons/chat_review.svg"
              />
              <h2>Review with a Loan Officer</h2>
              <span>
                We'll send a copy of this loan comparison to your loan officer
                for questions
              </span>

              <SlideUpModalInput
                label="Full Name"
                name="fullName"
                value={formik.values.fullName}
                onChange={formik.handleChange}
                error={formik.touched.fullName && formik.errors.fullName}
                helperText={formik.touched.fullName && formik.errors.fullName}
              />

              <SlideUpModalInput
                label="Phone Number"
                type="tel"
                name="phoneNumber"
                value={formik.values.phoneNumber}
                onChange={formik.handleChange}
                error={formik.touched.phoneNumber && formik.errors.phoneNumber}
                helperText={
                  formik.touched.phoneNumber && formik.errors.phoneNumber
                }
              />

              <SlideUpModalInput
                label="Email"
                type="email"
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && formik.errors.email}
                helperText={formik.touched.email && formik.errors.email}
              />

              <SlideUpModalInput
                label="Any notes or questions?"
                type="notes"
                name="notes"
                multiline
                value={formik.values.notes}
                onChange={formik.handleChange}
                error={formik.touched.notes && formik.errors.notes}
                helperText={formik.touched.notes && formik.errors.notes}
              />

              <div className="submit-button-container">
                <ModalSubmitButton type="submit" disabled={isLoading}>
                  {isLoading ? "Sending..." : "Send"}
                </ModalSubmitButton>
              </div>
            </Stack>
          </div>
        </form>
      )}
    </SlideUpModal>
  );
}
